$(window).load(function() {
    $("body").removeClass("preload");
});

$(document).ready(function(){

    scrollNavBar();
    $(document).scroll(function(){
        scrollNavBar();
    });
});

function scrollNavBar() {

    var offset = 35;
    var scrollTop = $(document).scrollTop();
    if(scrollTop > offset){
        $(".navbar-main").addClass("fixed");
    }
    else {
        $(".navbar-main").removeClass("fixed");
    }
}

$(document).ready(function(){
    $("#searchbar .close").click(function(){
        searchBarClose();
    });
    $(".searchbarOpen, .searchbarOpenInp").click(function(){
        searchBarOpen();
    });
    $(".searchbarOpenInp").click(function(){
        searchBarOpen();
    });
    $("#searchbar").click(function(event){
        if(event.target.id == 'searchbar') searchBarClose();
    });
    $("#avatar .remove").click(function(e){
        $("#avatar").remove();
        $("#noAvatar").val(1);
        e.preventDefault();
        return false;

    });
    $('[data-toggle="tooltip"]').tooltip();

    $('.aFilterMore').click( function(e) {

        if($('.filterMore').hasClass('hidden')) {
            $('.filterMore').removeClass('hidden');
            $('.aFilterMore').attr('title', $('.aFilterMore').data('less'));
            $('.aFilterMore i').removeClass().addClass('icon-mini-less');
        }else {
            $('.filterMore').addClass('hidden');
            $('.aFilterMore').attr('title', $('.aFilterMore').data('more'));
            $('.aFilterMore i').removeClass().addClass('icon-mini-more');
        }
        e.preventDefault();
    });
    var isModalTicket = false;
    $('.ticket.bt-sm').click( function(e) {
        isModalTicket = true;
    });
    $('.aFestival').click( function(e) {
        if(isModalTicket) {
            e.preventDefault();
        }
        isModalTicket = false;
    });


    $('.link').click(function(e) {
        if($(this).data('href')) {
            if($(this).hasClass('blank')) {
                window.open($(this).data('href'), '_blank');
            }else {
                document.location = $(this).data('href');
            }
        }
    });

});


function searchBarClose() {
    $('#searchbar').removeClass('open');
    $('#navbar').removeClass('open');
    $('#searchbar').height('');
    $('.searchbarOpen').show();
    $('.searchbarOpenInp').show();
    $('.searchbarOpenInp').val($('#searchMainInput').val());
}
function searchBarOpen() {
    $('#searchbar').addClass('open');
    $('.searchbarOpenInp').hide();
    $('.searchbarOpen').hide();
    $('#searchbar').height($( document ).height());
    $('#navbar').addClass('open');
    setTimeout(function(){
        $('#searchMainInput').focus();
        $('#searchMainInput').val($('#searchMainInput').val());
    },100);
    $( window ).resize(function() {
        if($('#searchbar').hasClass('open')) $('#searchbar').height($( document ).height());
    });
}

var searchFestivals = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    //prefetch: '../data/films/post_1960.json',
    remote: {
        url: '/festivals/recherche/%QUERY.json',
        wildcard: '%QUERY'
    }
});

$('#searchbar .searchTypeahead').typeahead(null, {
    name: 'festivals',
    display: 'value',
    limit: 9,
    source: searchFestivals,
    templates: {
        empty: [
            '<div class="empty-message">',
            'Aucun festival trouvé',
            '</div>'
        ].join('\n'),
        suggestion: function(data) {
            return data;
        }
    }
});
$('.searchTypeahead').keypress(function(e) {
    var code = (e.keyCode ? e.keyCode : e.which);
    if (code == 13) {
        e.preventDefault();
        e.stopPropagation();
        $('#searchFrom').submit();
    }
});
$('#searchSubmit').click( function() {
    $('#searchFrom').submit();
});

$.fn.scrollTo = function( target, options, callback ){
    if(typeof options == 'function' && arguments.length == 2){ callback = options; options = target; }
    var settings = $.extend({
        scrollTarget  : target,
        offsetTop     : 50,
        duration      : 500,
        easing        : 'swing'
    }, options);
    return this.each(function(){
        var scrollPane = $(this);
        var scrollTarget = (typeof settings.scrollTarget == "number") ? settings.scrollTarget : $(settings.scrollTarget);
        var scrollY = (typeof scrollTarget == "number") ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
        scrollPane.animate({scrollTop : scrollY }, parseInt(settings.duration), settings.easing, function(){
            if (typeof callback == 'function') { callback.call(this); }
        });
    });
}


// // Find all YouTube videos
// var $allVideos = $("iframe[src^='//www.youtube.com']"),
//
// // The element that is fluid width
//     $fluidEl = $("body");
//
// // Figure out and save aspect ratio for each video
// $allVideos.each(function() {
//
//     $(this)
//         .data('aspectRatio', this.height / this.width)
//
//         // and remove the hard coded width/height
//         .removeAttr('height')
//         .removeAttr('width');
//
// });
//
// // When the window is resized
// $(window).resize(function() {
//
//     var newWidth = $fluidEl.width();
//
//     // Resize all videos according to their own aspect ratio
//     $allVideos.each(function() {
//
//         var $el = $(this);
//         $el
//             .width(newWidth)
//             .height(newWidth * $el.data('aspectRatio'));
//
//     });
//
// // Kick off one resize to fix all videos on page load
// }).resize();

$('body').on('hidden.bs.modal', '.modal', function () {
    $(this).removeData('bs.modal');
});
$('body').on('hide.bs.modal', '.modal', function () {
    $(this).removeData('bs.modal');
});